export default class ChallengesTabs {
    constructor(query) {
        const el = document.querySelector(query);
        if (!el) return;

        this.el = el;
        this.tabs = this.el.querySelectorAll('.challenges__tab');
        this.panels = this.el.querySelectorAll('.challenges__panel');

        if (!this.tabs.length || !this.panels.length) return;

        this.init();
    }

    init() {
        this.tabs.forEach((tab) => {
            tab.addEventListener('click', () => {
                const index = tab.getAttribute('data-tab');

                this.changeTab(index);
            });
        });
    }

    changeTab(index) {
        this.tabs.forEach((tab) => {
            tab.classList.toggle('active', tab.dataset.tab === index);
        });

        this.panels.forEach((panel) => {
            const isActive = panel.dataset.panel === index;

            panel.classList.toggle('active', isActive);

            panel.querySelectorAll('.site-animation').forEach((item) => {
                item.classList.remove('animated');
            });

            if (isActive) {
                panel.querySelectorAll('.site-animation').forEach((item) => {
                    const delay = Number(item.dataset.delay) || 0;

                    setTimeout(() => {
                        item.classList.add('animated');
                    }, delay);
                });
            }
        });
    }
}